import { SetStateAction, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams, } from 'react-router-dom';
import TotvsBlackImg from '../../assets/images/logo-totvs-black.png';
import TotvsWhiteImg from '../../assets/images/logo-totvs-white.png';
import NinegridBlackImg from '../../assets/images/logo-ninegrid-black.png';
import NinegridWhiteImg from '../../assets/images/logo-ninegrid-white.png';
// import NinegridImg from '../../assets/images/ninegrid-logo.png';
// import TotvsImg from '../../assets/images/totvs-logo.png';
import { MainButton } from '../../components/MainButton';
import { useAppConfig } from '../../hooks/useAppConfig';
import { ConfigType } from '../../contexts/AppConfigContext';
import { Loading } from '../../components/Loading';
import './index.css';
import api from '../../services/api';
import { usePluginspace } from '../../hooks/usePluginspace';
import { useFoodConfig } from '../../hooks/useFood';
import { ModalComandaFood } from '../../components/ModalComandaFood/ModalComandaFood';
import { QrReader } from '../../components/QrCodeReader/QrCodeReader';


export function Home() {
    const navigate = useNavigate();
    const params = useParams();
    const { getAppConfig } = useAppConfig();
    const useFood = useFoodConfig()
    const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
    const [config, setConfig] = useState<ConfigType | void>();
    const [loading, setLoading] = useState(true);
    const [categoryId, setCategoryId] = useState('');
    const [pluginSpace, setPluginspace] = useState<any>()
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [isOpenModalFood, setIsOpenModalFood] = useState<boolean>(false)

    const [openCamera, setOpenCamera] = useState<boolean>(false)

    useEffect(() => {
        registerAccess('home')
        getConfig();

    }, [params]);
    async function getConfig() {
        const _config = await getAppConfig();
        // if (_config && (_config.template === "food" || _config.template === "retail") && _config.content.pdv.showLayout === 'l2') {
        //     await getCategory()
        // }
        setConfig(_config);
        setLoading(false);
        loadTableCard(_config);
    }

    function loadTableCard(_config: ConfigType | void) {
        localStorage.removeItem('table_number');
        localStorage.removeItem('table_name');
        localStorage.removeItem('card_number');
        localStorage.removeItem('card_name');
        localStorage.removeItem('internal_number');
        localStorage.removeItem('internal_name');
        localStorage.removeItem('landmark_synkar');
        localStorage.removeItem('counter_number');


        const isKicked = searchParams.get('kicked');

        const reload_app_food = localStorage.getItem('reload_app_food')
        const first_access = localStorage.getItem('first_access')

        if (!reload_app_food || !first_access) {

            localStorage.removeItem('food_customer_phone');
            localStorage.removeItem('food_customer_name');
            localStorage.removeItem('food_customer_call_waiter');
        }

        if (isKicked) {
            localStorage.setItem('was_kicked', 'true');
        } else {
            localStorage.removeItem('was_kicked');
        }



        if (params.landmark_synkar) {
            useFood.setIsLandmark(true)
            useFood.setLandMarkNumber(parseInt(window.atob(params.landmark_synkar)))
            localStorage.setItem('landmark_synkar', params.landmark_synkar)
        }
        if (params.table_number) {
            useFood.setIsTable(true)
            useFood.setTableNumber(parseInt(window.atob(params.table_number)))
            localStorage.setItem('table_number', params.table_number)
            localStorage.setItem('should_show_ler_qrcodeButton', 'true');
        }
        if (params.table_name) {
            useFood.setTableName(params.table_name)
            localStorage.setItem('table_name', params.table_name)
        }
        if (params.card_number) {
            useFood.setIsCard(true)
            useFood.setCardNumber(parseInt(window.atob(params.card_number)))
            localStorage.setItem('card_number', params.card_number)
            localStorage.setItem('should_show_ler_qrcodeButton', 'true');
        }
        if (params.card_name) {
            useFood.setCardName(params.card_name)
            localStorage.setItem('card_name', params.card_name)
        }
        if (params.counter_number) {
            useFood.setIsCounter(true)
            useFood.setCounterNumber(parseInt(params.counter_number))
            localStorage.setItem('counter_number', params.counter_number)
        }
        if (params.internal_number) {
            useFood.setIsInternalDelivery(true)
            useFood.setInternalDeliveryNumber(parseInt(window.atob((params.internal_number))))
            localStorage.setItem('internal_number', params.internal_number)
        }
        if (params.internal_name) {
            useFood.setInternalDeliveryName(params.internal_name)
            localStorage.setItem('internal_name', params.internal_name)
        }
        if (params.table_number || params.card_number || params.landmark_synkar || params.counter_number || params.internal_number || isKicked) {
            localStorage.setItem(window.btoa('last_time_qrcode'), new Date().getTime().toString())
            const configuration: any = _config ? _config : config;

            if (!params.table_number && !params.card_number && (!isKicked)) {
                if (configuration && configuration.content) {
                    if (configuration.content.pdv.showLayout === 'l2') {
                        navigate(`/${params.pluginspace_id}/products-new`, { replace: true });
                    } else {
                        navigate(`/${params.pluginspace_id}/products`, { replace: true });
                    }
                } else {
                    navigate(`/${params.pluginspace_id}/products`, { replace: true });
                }
            } else if (configuration.content.pdv.safeMode) {
                setIsOpenModalFood(true)

                return
            }
        } else {
            localStorage.removeItem(window.btoa('last_time_qrcode'))
        }



        if (_config && _config.content && _config.content.pdv && _config.content.pdv.skipEntry && !isKicked) {
            enter(_config)
        }
    }

    async function getCategory() {
        setLoading(true);
        await api.post('/api/classification/filter',
            {
                code: '1',
            },
            {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            }).then(async (response) => {
                if (response.data.data[0]) {
                    setCategoryId(response.data.data[0].id);
                }
            })
            .catch((err) => {
                setLoading(false);
            })
    }


    function readQrcode(value: string) {
        try {
            if (value) {
                window.open(value, "_self")

            }

        } catch (error) {
            console.log(error)
        }
    }


    async function enter(_config?: ConfigType | void) {
        const configuration = _config ? _config : config;
        if (configuration && (configuration.template === "retail" || configuration.template === "food")) {
            if (configuration.content.pdv.showLayout === 'l2') {
                navigate(`/${params.pluginspace_id}/products-new`);
            } else {
                navigate(`/${params.pluginspace_id}/products`);
            }
        } else {
            navigate(`/${params.pluginspace_id}/category`);
        }
    }

    function login() {
        navigate(`/${params.pluginspace_id}/auth`)
    }

    async function getData() {
        const x = await getThisPluginspace()
        if (x) {
            setPluginspace(x)
        }

    }

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        // Adiciona um novo estado no histórico atual
        window.history.pushState(null, '', window.location.href);
  
    
        const bloquearVoltar = () => {
            // Reinsere a URL atual para bloquear voltar
            window.history.pushState(null, '', window.location.href);
           
        };
    
        // Escuta eventos de voltar
        window.addEventListener('popstate', bloquearVoltar);
    
    
        // Remove o listener ao desmontar o componente
        return () => {
            window.removeEventListener('popstate', bloquearVoltar);
            
        };
    }, []);

    useEffect(() => {
        // Bloqueia a interação do usuário
        document.body.style.pointerEvents = 'none';
        

        // Desbloqueia a interação do usuário após 1 segundo
        const timer = setTimeout(() => {
            document.body.style.pointerEvents = 'auto';
            
        }, 1000);

        // Limpa o timer ao desmontar o componente
        return () => clearTimeout(timer);
    }, []);


    return (
        <div className="home">
            {loading ?
                <div style={{ width: '100%', height: 'calc(100vh)' }}>
                    <Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
                </div>
                :
                <div
                    className="content-home"
                    style={config?.background ? {
                        backgroundImage: `url(${config?.background})`,
                        backgroundSize: 'cover',
                    } : { backgroundColor: config?.webappcolor.backgroundwebapp ? config?.webappcolor.backgroundwebapp : '#FFF' }}
                >

                    <div className="logo-home">
                        {(config?.img && !config.img.includes('null')) &&
                            <img src={config.img} alt="Logo" />
                        }
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: config?.info ? config.info : '' }}>
                    </div>
                    <div className="actions-homes">
                        {pluginSpace?.appLogin && pluginSpace?.appLogin && <>
                            <MainButton
                                color={config?.webappcolor.fontbuttonhome ? config.webappcolor.fontbuttonhome : '#636363'}
                                backgroundColor={config?.webappcolor.backgroundbuttonhome ? '#AAA' : '#AAA'}
                                text="Login" onClick={login}
                            />
                        </>
                        }
                        <MainButton
                            color={config?.webappcolor.fontbuttonhome ? config.webappcolor.fontbuttonhome : '#636363'}
                            backgroundColor={config?.webappcolor.backgroundbuttonhome ? config.webappcolor.backgroundbuttonhome : '#EAEAEA'}
                            text="Entrar" onClick={() => enter()}
                        />
                    </div>
                    <div className="footer-home">
                        {config?.content.useLogoTotvs &&
                            <img src={config && config.content && config.content.colorLogo === 'white' ? TotvsWhiteImg : TotvsBlackImg} alt="TOTVS" className='totvs-img' />
                        }
                        {config?.content.useLogoTotvs &&
                            <h2 style={{ color: config && config.content && config.content.colorLogo === 'white' ? 'white' : 'black' }}>by</h2>
                        }
                        <img src={config && config.content && config.content.colorLogo === 'white' ? NinegridWhiteImg : NinegridBlackImg} alt="Ninegrid by pluginbot" className='ninegrid-img' />
                    </div>
                </div>
            }

            <ModalComandaFood isOpen={isOpenModalFood} setIsOpen={setIsOpenModalFood}
                enter={enter} />

            {openCamera && <QrReader setScannedResult={readQrcode} />}
        </div>

    )
}